import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { DashboardMovimientosPorTipoMovimientoRequest, EnviarDetalleDeudaRequestDto, EnviarDetalleDeudaResponseDto, ExportMediaTypeConstants, FinanciarDeudaDto, GenerarMovimientoDeudaDto, GenerarMovimientoPagoDto, GenerarMovimientoPagoMasivoRequestDto, GenerarMovimientoPagoMasivoResponseDto, GenericPieDashboardResponse, ProcessFromPagosExcelRequestDto, ProcessFromPagosExcelResponseDto } from "../model/index"; 
import { GenericResponse, GenericSearchResponse, GetSaldoRequestDto, GetSaldoResponseDto, MovimientoAdjunto, SaveMovimientoFromDocumentRequestDto, SaveMovimientoFromDocumentResponseDto } from "../model/index"; 
import { SaveMovimientoRequestDto, SearchMovimientoRecurrenteRequest, SearchReporteCuentasDeudorasRequest, UploadMovimientoAttachResponseDto } from "../model/index"; 
import { Movimiento, SearchMovimientoRequest, SearchReporteEstadoCuentasRequestDto, SearchReporteConsolidadoCajaRequestDto } from "../model/index";

@Injectable({
  providedIn: 'root'
})
export class MovimientoService extends CrudService<Movimiento, number, SaveMovimientoRequestDto, SearchMovimientoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'movimiento', sharedFunctions);

  }

  getMySearchUrl() {
    return this._serviceUrl + '/my-search';
  }

  searchReporteConsolidadoCajaUrl() {
    return this._serviceUrl + '/reporte-consolidado-caja';
  }

  searchReporteConsolidadoCajaDetalleUrl() {
    return this._serviceUrl + '/reporte-consolidado-caja-detalle';
  }

  searchReporteCuentasDeudorasUrl() {
    return this._serviceUrl + '/reporte-cuentas-deudoras';
  }

  getDashboardMisPagosUrl() {
    return this._serviceUrl + '/dashboard-mis-pagos';
  }

  getDashboardMiResumenSaldoUrl() {
    return this._serviceUrl + '/dashboard-mi-resumen-saldo';
  }

  getAttachments(id: number): Observable<GenericResponse<MovimientoAdjunto[]>> {
    return this._http.get<GenericResponse<MovimientoAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getMovimientosRecurrentes(p: SearchMovimientoRecurrenteRequest): Observable<any> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<any>(this._serviceUrl + '/movimientos-recurrentes'  +query, this.httpOptions);
  }

  exportReporteEstadoCuentas(value: SearchReporteEstadoCuentasRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-estado-cuentas' + queryString, this.httpCsvOptions);
  }

  getReporteEstadoCuentasContactos(cuentaId: number): Observable<GenericResponse<any>> {
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-cuentas-deudoras-contactos/'+cuentaId, this.httpOptions);
  }

  getReporteEstadoCuentasEstadisticas(p: SearchReporteEstadoCuentasRequestDto): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-estado-cuentas-statistics' + query, this.httpOptions);
  }

  exportReporteEstadoCuentasContactos(value: SearchMovimientoRequest): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-cuentas-deudoras-contactos' + queryString, this.httpCsvOptions);
  }

  enviarDetalleDeuda(p: EnviarDetalleDeudaRequestDto): Observable<GenericResponse<EnviarDetalleDeudaResponseDto>> {
    return this._http.post<GenericResponse<EnviarDetalleDeudaResponseDto>>(this._serviceUrl + '/enviar-detalle-deuda', p, this.httpOptions);
  }

  getReporteConsolidadoCajaEstadisticas(p: SearchReporteConsolidadoCajaRequestDto): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-consolidado-caja-statistics' + query, this.httpOptions);
  }

  getReporteConsolidadoCaja(p: SearchReporteConsolidadoCajaRequestDto): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-consolidado-caja' + query, this.httpOptions);
  }

  exportReporteConsolidadoCaja(value: SearchReporteConsolidadoCajaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-consolidado-caja' + queryString, this.httpCsvOptions);
  }

  exportReporteConsolidadoCajaConDetalles(value: SearchReporteConsolidadoCajaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-consolidado-caja-detalles' + queryString, this.httpCsvOptions);
  }

  getReporteConsolidadoCajaDetalle(p: SearchReporteConsolidadoCajaRequestDto): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-consolidado-caja-detalle' + query, this.httpOptions);
  }

  exportReporteConsolidadoCajaDetalle(value: SearchReporteConsolidadoCajaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-consolidado-caja-detalle' + queryString, this.httpCsvOptions);
  }

  getReporteCuentasDeudorasEstadisticas(p: SearchReporteCuentasDeudorasRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-cuentas-deudoras-statistics' + query, this.httpOptions);
  }

  getReporteCuentasDeudoras(p: SearchReporteCuentasDeudorasRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/reporte-cuentas-deudoras' + query, this.httpOptions);
  }

  exportReporteCuentasDeudoras(value: SearchReporteCuentasDeudorasRequest): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-cuentas-deudoras' + queryString, this.httpCsvOptions);
  }

  getDashboardResumenCaja(p: any): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/dashboard-resumen-caja' + query, this.httpOptions);
  }

  getPagos(id: number): Observable<GenericResponse<Movimiento[]>> {
    return this._http.get<GenericResponse<Movimiento[]>>(this._serviceUrl + '/pagos/' + id, this.httpOptions);
  }

  getDeudas(id: number): Observable<GenericResponse<Movimiento[]>> { 
    return this._http.get<GenericResponse<Movimiento[]>>(this._serviceUrl + '/deudas/' + id, this.httpOptions);
  }

  getSearchEstadisticas(p: SearchMovimientoRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/search-statistics' + query, this.httpOptions);
  }

  getMySearchEstadisticas(p: SearchMovimientoRequest): Observable<GenericResponse<any>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<any>>(this._serviceUrl + '/my-search-statistics' + query, this.httpOptions);
  }

  searchMisMovmientos(value: SearchMovimientoRequest): Observable<GenericSearchResponse<any>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericSearchResponse<any>>(this.getMySearchUrl() + queryString, this.httpOptions);
  }

  exportMisMovmientos(value: SearchMovimientoRequest): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-my-search' + queryString, this.httpCsvOptions);
  }

  getMiMovimiento(id: number): Observable<GenericResponse<Movimiento>> {
    return this._http.get<GenericResponse<Movimiento>>(this._serviceUrl + '/my/' + id, this.httpOptions);
  }

  getSaldo(value: GetSaldoRequestDto): Observable<GenericResponse<GetSaldoResponseDto>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericResponse<GetSaldoResponseDto>>(this._serviceUrl + '/saldo' + queryString, this.httpOptions);
  }

  getMiSaldo(value: GetSaldoRequestDto): Observable<GenericResponse<GetSaldoResponseDto>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericResponse<GetSaldoResponseDto>>(this._serviceUrl + '/my-saldo' + queryString, this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  cleanTempFolderUrl(): string {
    return this._serviceUrl + '/clean/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadMovimientoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadMovimientoAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  clearTempFolder(): Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this.cleanTempFolderUrl(), null, this.httpOptions);
  }

  generarPago(p: GenerarMovimientoPagoDto) : Observable<GenericResponse<number>> {
    return this._http.post<GenericResponse<number>>(this._serviceUrl+"/generar-pago", p, this.httpOptions);
  }

  generarPagos(p: GenerarMovimientoPagoMasivoRequestDto) : Observable<GenericResponse<GenerarMovimientoPagoMasivoResponseDto[]>> {
    return this._http.post<GenericResponse<GenerarMovimientoPagoMasivoResponseDto[]>>(this._serviceUrl+"/generar-pagos", p, this.httpOptions);
  }

  generarDeuda(p: GenerarMovimientoDeudaDto) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/generar-deuda", p, this.httpOptions);
  }

  generarDeudas(p: GenerarMovimientoDeudaDto[]) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/generar-deudas", p, this.httpOptions);
  }

  generarMovimientosRecurrentes(p: GenerarMovimientoDeudaDto[]) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/generar-movimientos-recurrentes", p, this.httpOptions);
  }

  financiarDeuda(p: FinanciarDeudaDto) : Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl+"/financiar-deuda", p, this.httpOptions);
  }

  aprobar(id: number) : Observable<GenericResponse<Movimiento[]>> {
    return this._http.post<GenericResponse<Movimiento[]>>(this._serviceUrl+"/aprobar/"+id, null, this.httpOptions);
  }

  cancelar(id: number) : Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl+"/cancelar/"+id, null, this.httpOptions);
  }

  cancelacionMasiva(id: number[]) : Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl+"/cancelacion-masiva", { Ids: id }, this.httpOptions);
  }

  generarReciboPago(pagoId: number): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/generar-recibo-pago/' + pagoId, this.httpPdfOptions);
  }

  obtenerDashboardMovimientosPorTipoMovimiento(p: DashboardMovimientosPorTipoMovimientoRequest): Observable<GenericResponse<GenericPieDashboardResponse>> {
    var query = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericResponse<GenericPieDashboardResponse>>(this._serviceUrl + '/dashboard-movimientos-por-tipo-movimiento' + query, this.httpOptions);
  }

  generarDesdeDocumentos(p: SaveMovimientoFromDocumentRequestDto) : Observable<GenericResponse<SaveMovimientoFromDocumentResponseDto>> {
    return this._http.post<GenericResponse<SaveMovimientoFromDocumentResponseDto>>(this._serviceUrl+"/generar-desde-documentos", p, this.httpOptions);
  }

  runJobSegundoVencimiento(p: any) : Observable<GenericResponse<any>> {
    return this._http.post<GenericResponse<any>>(this._serviceUrl+"/job/update-segundo-vencimiento", p, this.httpOptions);
  }

  downloadImportPagosTemplate(): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/download-import-pagos-template', this.httpCsvOptions);
  }

  exportSearchPagosMasivos(value: SearchMovimientoRequest, mediaType: ExportMediaTypeConstants = ExportMediaTypeConstants.Excel): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value, mediaType);
    return this._http.get<any>(this._serviceUrl + '/export-search-pagos-masivos' + queryString, this.httpCsvOptions);
  }

  processPagosExcel(p: ProcessFromPagosExcelRequestDto) : Observable<GenericResponse<ProcessFromPagosExcelResponseDto>> {
    return this._http.post<GenericResponse<ProcessFromPagosExcelResponseDto>>(this._serviceUrl+"/process-pagos-excel", p, this.httpOptions);
  }
}